import { createReducer, on } from '@ngrx/store';
import { HomeMyRecommendationGeneralHealthActions } from './general-health.actions';
import {
  HomeMyRecommendationGeneralHealthState,
  homeMyRecommendationGeneralHealthState
} from './general-health.state';

export const homeMyRecommendationGeneralHealthReducer = createReducer(
  homeMyRecommendationGeneralHealthState,
  on(
    HomeMyRecommendationGeneralHealthActions.reset,
    (): HomeMyRecommendationGeneralHealthState => ({ data: [] })
  ),
  on(
    HomeMyRecommendationGeneralHealthActions.setData,
    (state, { data }): HomeMyRecommendationGeneralHealthState => ({
      ...state,
      data
    })
  )
);
